import { render } from "./Ownership.vue?vue&type=template&id=a0330fe6&scoped=true"
import script from "./Ownership.vue?vue&type=script&lang=js"
export * from "./Ownership.vue?vue&type=script&lang=js"

import "./Ownership.vue?vue&type=style&index=0&id=a0330fe6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0330fe6"]])

export default __exports__